import React, { useState } from 'react';
import { VEO_STYLE_PRESETS } from '../../../services/veoService';

interface VeoStylePresetsProps {
  onPresetSelect: (preset: any) => void;
}

const VeoStylePresets: React.FC<VeoStylePresetsProps> = ({
  onPresetSelect
}) => {
  const [selectedPresetId, setSelectedPresetId] = useState<string>('');

  const handlePresetClick = (preset: any) => {
    setSelectedPresetId(preset.id);
    onPresetSelect(preset);
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <h4 style={{ 
        margin: '0 0 12px 0', 
        fontSize: '14px', 
        fontWeight: '500',
        color: '#fff'
      }}>
        🎬 Quick Style Presets:
      </h4>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', 
        gap: '10px' 
      }}>
        {VEO_STYLE_PRESETS.map((preset) => {
          const isSelected = selectedPresetId === preset.id;
          
          return (
            <div
              key={preset.id}
              onClick={() => handlePresetClick(preset)}
              style={{
                padding: '12px',
                border: isSelected 
                  ? '2px solid #8b5cf6' 
                  : '1px solid rgba(139, 92, 246, 0.3)',
                borderRadius: '6px',
                backgroundColor: isSelected 
                  ? 'rgba(139, 92, 246, 0.1)' 
                  : '#1a1a1a',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = '#8b5cf6';
                  e.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.3)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                }
              }}
            >
              {/* Selection Indicator */}
              {isSelected && (
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  backgroundColor: '#8b5cf6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span style={{ 
                    color: '#fff', 
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </span>
                </div>
              )}
              
              <div style={{ 
                fontSize: '13px', 
                fontWeight: '600',
                color: isSelected ? '#8b5cf6' : '#fff',
                marginBottom: '4px'
              }}>
                {preset.name}
              </div>
              
              <div style={{ 
                fontSize: '11px', 
                color: '#ccc',
                marginBottom: '6px',
                lineHeight: '1.3'
              }}>
                {preset.description}
              </div>
              
              <div style={{ 
                fontSize: '10px', 
                color: isSelected ? '#8b5cf6' : '#8b5cf6',
                fontWeight: '500'
              }}>
                {preset.use_case}
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Clear Selection Button */}
      {selectedPresetId && (
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <button
            onClick={() => setSelectedPresetId('')}
            style={{
              padding: '6px 12px',
              backgroundColor: 'transparent',
              border: '1px solid rgba(139, 92, 246, 0.3)',
              borderRadius: '4px',
              color: '#8b5cf6',
              fontSize: '11px',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            Clear Selection
          </button>
        </div>
      )}
      
      <div style={{
        marginTop: '10px',
        padding: '8px 12px',
        backgroundColor: 'rgba(139, 92, 246, 0.05)',
        borderRadius: '4px',
        border: '1px solid rgba(139, 92, 246, 0.2)'
      }}>
        <p style={{ 
          margin: 0, 
          fontSize: '11px', 
          color: '#ccc'
        }}>
          💡 Click a preset to automatically apply visual style, lighting, and camera settings
        </p>
      </div>
    </div>
  );
};

export default VeoStylePresets;